export const badgeAnchorOrigin = { vertical: 'bottom', horizontal: 'right' } as const;
